import 'handsontable';
import HandsontableFunctions from '../../../../../modules/VerzekeringsInzicht/App/handsontable/handsontableFunctions.js';
import HandsontableControls from '../../../../../modules/VerzekeringsInzicht/App/handsontable/handsontableControls.js';
import HandsontableRenderers from '../../../../../modules/VerzekeringsInzicht/App/handsontable/handsontableRenderers.js';
import HandsontableValidators from '../../../../../modules/VerzekeringsInzicht/App/handsontable/handsontableValidators.js';
import bootstrapNotify from '../../../../../modules/Gull/Framework/bootstrapNotify.js';
import validation from '../../../../../modules/Gull/Framework/validation.js';

const addMultipleView = {
	init: function () {
		if (typeof window.app.router !== 'undefined' && (window.app.router.routerType || 'build') === 'dev') {
			setTimeout(async () => {
				addMultipleView.initGrid();
			}, 200);
		} else {
			setTimeout(async () => {
				const vendor = await import('../../../../../modules/VerzekeringsInzicht/App/handsontable/handsontableLoader.js');
				addMultipleView.initGrid();
			}, 200);
		}
	},

	initGrid: function () {
		// Check if handsontable element exists in dom
		if (document.getElementById('handsontable')) {
			HandsontableControls.init();
			HandsontableRenderers.init();
			HandsontableValidators.init();

			// Define Handsontable Element and get settings from DOM
			var hotEl = document.getElementById('handsontable');
			var werknemers = JSON.parse(hotEl.getAttribute('data-werknemers'));
			var werknemersMeldingIds = JSON.parse(hotEl.getAttribute('data-werknemersMeldingIds'));
			var relatieId = $('#handsontable').attr('data-relatie-id');

			// Definieer Handsontable columns
			var columns = {
				settings: [
					{
						type: 'dropdown',
						className: 'htMiddle',
						allowEmpty: false,
						source: werknemers,
					},
					{
						type: 'dropdown',
						className: 'htMiddle',
						validator: 'notEmpty',
						allowEmpty: false,
					},
					{
						type: 'date',
						className: 'htMiddle',
						allowEmpty: false,
						dateFormat: 'DD-MM-YYYY',
						correctFormat: true,
					},
					{
						type: 'date',
						className: 'htMiddle',
						allowEmpty: false,
						dateFormat: 'DD-MM-YYYY',
						correctFormat: true,
					},
					{
						type: 'numeric',
						className: 'htMiddle',
						allowEmpty: false,
						renderer: 'bedrag',
						numericFormat: {
							pattern: '€0,0',
							culture: 'nl-NL',
						},
						validator: 'salarisNegativeAndZeroAllowedOrEmpty',
						formatter: 'currencyNoSeparator',
					},
					{
						type: 'numeric',
						className: 'htMiddle',
						allowEmpty: false,
						renderer: 'bedrag',
						numericFormat: {
							pattern: '€0,0',
							culture: 'nl-NL',
						},
						validator: 'salarisNegativeAllowed',
						formatter: 'currencyNoSeparator',
					},
				],
				tooltips: [null, 'Selecteer het juiste dossier op basis van de combinatie dossiernummer, eerste ziektedag en de begindatum van het dossier. Bij twijfel kunt u het juiste dossier bepalen door op medewerker niveau de meldingen te bekijken.', null, null, 'Op maand basis', null],
			};

			// Definieer Handsontable dummy data
			var data = [['', '', '', '', '0', '0']];

			// Definieer Handsontable Settings
			var hotSettings = {
				colHeaders: ['Werknemer', 'Melding / 1e ziektedag / Begindatum', 'Periode van', 'Periode tot', 'Bruto loon', 'Factuurbedrag'],
				contextMenu: ['row_above', 'row_below', 'remove_row'],
				colWidths: [200, 260, 100, 100, 100, 100],
				data: data,
				fillHandle: false,
				columns: columns.settings,
				language: 'nl-NL',
				licenseKey: 'non-commercial-and-evaluation',
				rowHeights: 30,
				stretchH: 'all',
				copyPaste: false,
				outsideClickDeselects: false,
				afterSetDataAtCell: function (changes) {
					addMultipleView.updateDossiernummers(changes, relatieId, werknemersMeldingIds);
				},
				afterChange: function (changes, source) {
					setTimeout(function () {
						document.getElementsByName('werknemersDataJSON')[0].value = JSON.stringify(window.app.hot.getData());
						HandsontableFunctions.formatAfterChange(changes, source, columns, window.app.hot);
					}, 0);
					HandsontableFunctions.disableForPaste(hotEl, source, false);
				},
				beforeChange: function (changes, source) {
					HandsontableFunctions.disableForPaste(hotEl, source);
				},
				afterGetColHeader: function (col, th) {
					HandsontableFunctions.createHeaderTooltip(col, th, columns);
				},
				afterInit: function () {
					// Verberg loading spinner
					var element = document.getElementById('handsontableLoader');
					element.parentNode.removeChild(element);

					// Maak form button enabled
					setTimeout(function () {
						$('form[data-validate] button[type=button]').removeAttr('disabled');
					}, 0);
				},
			};

			// Init Handsontable instance
			window.app.hot = new window.Handsontable(hotEl, hotSettings);

			// Toon en verberg juiste opvolgende velden op basis van ingevoerde waarde in betalingAan
			$('#betalingAan').change(function (e) {
				e.preventDefault();
				// Verberg melding over betaalbewijs
				$('.melding-betaling-werkgever').addClass('d-none');
				// Verberg melding over UWV
				$('.melding-betaling-uwv').addClass('d-none');
				// Disable iban voor submit
				$('#IBAN').attr('name', '').closest('.form-group').addClass('d-none');
				// Disable volgnummer iban voor submit
				$('#VOLGNR_BANK').attr('name', '');
				// Verberg melding dat er geen iban bekend is
				$('.melding-geen-iban').addClass('d-none');
				// Verberg bewijsoverboeking upload
				$('#bewijsOverboeking').closest('.form-group').addClass('d-none');
				// Verwijder validatie op overboekingsbewijs
				validation.removeRequired($('#bewijsOverboeking'));
				// Verwijder validatie op iban
				validation.removeRequired($('#IBAN'));
				if ($(this).val() == 'werkgever') {
					// Toon melding over betaalbewijs
					$('.melding-betaling-werkgever').removeClass('d-none');
					// Toon toon bewijs van overboeking
					$('#bewijsOverboeking').closest('.form-group').removeClass('d-none');
					// Voeg attribuut name weer toe
					$('#IBAN').attr('name', 'IBAN').closest('.form-group').removeClass('d-none');
					// Enable Volgnummer iban voor submit
					$('#VOLGNR_BANK').attr('name', 'VOLGNR_BANK');
					// Toon melding dat er geen iban bekend is
					$('.melding-geen-iban').removeClass('d-none');
					// Voeg required toe aan iban
					validation.addRequired($('#IBAN'));
					if ($(this).data('company') !== 'C030') {
						// Voeg validatie toe aan bewijs van overboeking
						validation.addRequired($('#bewijsOverboeking'));
					}
					if ($('#IBAN').length < 1) {
						$('#form-beschikking button').attr('disabled', true);
					}
				} else {
					// Toon melding over UWV
					$('.melding-betaling-uwv').removeClass('d-none');
					$('#form-beschikking button').removeAttr('disabled');
				}
			});

			// Toon en verberg functie uit als pagina geladen wordt
			$('#betalingAan').trigger('change');

			// Wijzig volgnummer veld als andere iban wordt geselecteerd
			$('#IBAN').change(function (e) {
				$('input[name=VOLGNR_BANK').val($(e.target).children('option:selected').data('nr'));
			});

			// Valideer velden onBlur
			$('form.form-beschikking').find('input,select,textarea').filter('[data-validate]').blur(validation.checkInputBlur);

			// Submit functie die checkt of het grid gevalideerd wordt voor submit
			$('form.form-beschikking button[type=submit].btn-submit').attr('type', 'button').removeAttr('disabled');
			$('form.form-beschikking button[type=button].btn-submit').on('click', async function () {
				return await addMultipleView.validateComplete();
			});

			// Bind functie die de ingevoerde gegevens in het formulier submit aan button in modal
			$('#modalBevestigen').on('click', '.btn-submit-confirm', function () {
				addMultipleView.submitForm();
			});
		}
	},

	// Update dossiernummer cell op basis van gekozen werknemer
	updateDossiernummers: function (changes, relatieId, werknemersMeldingIds) {
		// Voer voor elke gewijzigde cel functie uit
		$.each(changes, function (i, e) {
			// Definieer column van betreffende wijziging
			var column = e[1];

			// Als het column 1 betreft
			if (column == 0) {
				// Definieer row van betreffende wijziging
				var rowNumber = e[0];

				// Definieer column waarin functie uitgevoerd moet worden
				var colNumber = 1;

				// Verkrijg werknemer van betreffende wijziging
				var werknemer = e[3];

				// Definieer werknemnerID op basis van array uit dom
				var werknemerId = werknemersMeldingIds[werknemer];

				// Voer ajax request uit die open meldingen van werknemer teruggeeft
				$.getJSON(window.app.ajaxPath + relatieId + '/data/' + werknemerId).done(function (d) {
					// Verwijder de huidige waarde uit de cel (om te voorkomen dat er een reeds geselecteerde waarde gesubmit wordt)
					window.app.hot.setDataAtCell(rowNumber, colNumber, '');

					// Maak nieuwe array aan met de cell eigenschappen
					var cellProp = {};

					// Maak opties array aan
					var opties = [];

					// Geef de cell het type "dropdown"
					cellProp.type = 'dropdown';

					// Als er meldingen worden teruggegeven
					if (d !== '') {
						// Verkrijg de meldingen als array uit ajax response
						var meldingen = d;

						// Verkrijg de reeds geselecteerde meldingen als array
						var selected = window.app.hot.getDataAtCol(1);

						// Haal de reeds geselecteerde meldingen af van de meldingen
						opties = meldingen.filter((n) => !selected.includes(n));

						// Kies eerste item uit melding
						if (opties.length) {
							window.app.hot.setDataAtCell(rowNumber, colNumber, opties[0]);
						}

						// Als er geen beschikbare meldingen terug gegeven worden
					} else {
						window.app.hot.setDataAtCell(rowNumber, colNumber, 'Reeds een lopende betalingsaanvraag aanvraag...');

						// Geef dan een melding
						bootstrapNotify('danger', '', 'Het is niet mogelijk een dossier te selecteren voor deze medewerker omdat er nog een ander betaalverzoek in behandeling is.', 5000);
					}

					// Geef de opties van de select
					cellProp.source = opties;

					// Voeg nieuwe cel van het type dropdown met de de nog niet eerde geselecteerde meldingen toe op de juiste plek in de tabel
					window.app.hot.setCellMetaObject(rowNumber, colNumber, cellProp);
				});
			}
		});
	},

	// Functie die de ingevoerde gegevens in het formulier submit
	submitForm: function () {
		$('#modalBevestigen').modal('hide');
		setTimeout(function () {
			$('form.form-beschikking')[0].submit();
		}, 200);
	},

	// Functie om volledige pagina te valideren
	validateComplete: async function () {
		// Valideer formulier en geef indien nodig foutmelding
		var aantalFouten = 0;
		$('form.form-beschikking')
			.find('input[data-validate],select[data-validate],textarea[data-validate]')
			.each(function () {
				if (validation.checkInput(this) == 'error') {
					aantalFouten = aantalFouten + 1;
				}
			});
		if (aantalFouten > 0) {
			bootstrapNotify('danger', '', 'Er zijn fouten gevonden in het formulier. Deze moet gecorrigeerd worden om het formulier te versturen.', 5000);
		}

		// Valideer grid en geef indien nodig foutmelding
		window.app.hot.validateCells(function () {
			if (HandsontableFunctions.isValid(window.app.hot) && HandsontableFunctions.hasRows(window.app.hot) && aantalFouten == 0) {
				$('#modalBevestigen').modal('show', {
					keyboard: false,
					backdrop: 'static',
				});
			} else {
				bootstrapNotify('danger', '', 'Er zijn fouten gevonden in het grid. Zorg dat er tenminste één werknemer is toegevoegd en corrigeer roodgekleurde cellen.', 5000);
			}
			return false;
		});
	},
};

export default addMultipleView;
